import Div from "components/primitives/Div";
import SettingsIcon from "components/Icons/SettingsIcon";
import useSidebar from "../../SidebarProvider/useSidebar";
import { useTranslation } from "react-i18next";
import TooltipHelper from "components/TooltipHelper";
import { SettingsIconContainer } from "..";

function SettingMenuAction() {
  const { open } = useSidebar();
  const { t } = useTranslation();

  return (
    <Div>
      <TooltipHelper placement="top" title={open ? t("global.settings_menu_label") : null}>
        <SettingsIconContainer>
          <SettingsIcon fontSize="small" />
        </SettingsIconContainer>
      </TooltipHelper>
    </Div>
  );
}

export default SettingMenuAction;
